import React from 'react';
import {Link} from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {LogoutIcon} from "../../../../helpers/Icons";

function LogoutAppBar() {

  return(
    <Tabs value='logout' variant="scrollable">
      <Tab label="Logout" icon={<LogoutIcon />} value="logout" component={Link} to="/logout" />
    </Tabs>
  )
}
export default LogoutAppBar
